<style lang="scss">
    @import '~@/abstracts/_variables.scss';

    div.filters-container {
        background-color: white;
        position: fixed;
        left: 0;
        bottom: 0;
        top: 75px;
        max-width: 400px;
        width: 100%;
        padding-top: 10px;
        box-shadow: 0 2px 4px 0 rgba(3,27,78,0.10);
        z-index: 99;

        span.clear-filters {
            font-size: 16px;
            color: $text-secondary-color;
            font-family: 'Raleway', sans-serif;
            cursor: pointer;
            display: block;
            float: left;
            margin-bottom: 20px;
            display: none;

            img{
                margin-right: 10px;
                float: left;
                margin-top: 6px;
            }
        }

        div.validation {
            color: #D0021B;
            font-family: 'Raleway', sans-serif;
            font-size: 14px;
            margin-bottom: 15px;
            text-align: center;
        }

        span.filters-header {
            display: block;
            font-family: 'Raleway', sans-serif;
            text-align: left;
            font-weight: 500;
            margin-left: 5px;
            margin-top: 20px;
            margin-bottom: 5px;
        }

        input[type="text"].search {
            box-shadow: none;
            border-radius: 5px;
            border: 1px solid #BFC1C4;
            color: #BABABA;
            font-size: 16px;
            font-family: 'Raleway', sans-serif;
            background-image: url('/img/search-icon-orange.svg');
            background-repeat: no-repeat;
            background-position: 8px;
            background: none;
            padding-left: 15px;
            padding-top: 5px;
            padding-bottom: 5px;
        }

        label.filter-label {
            font-family: 'Raleway', sans-serif;
            text-align: left;
            color: black;
            font-weight: 500;
            margin-left: 5px;
            margin-top: 20px;
            margin-bottom: 5px;
        }

        div.services {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 10px;

            button.service-button {
                font-family: 'Raleway', sans-serif;
                background-color: #eee;
                border: none;
                color: #333;
                padding: 10px 13px;
                border-radius: 5px;
                cursor: pointer;
                font-size: 16px;
                font-weight: 500;
                display: flex;
                align-items: center;
                gap: 5px;
                transition: background-color 0.3s;
                width: fit-content;

                &:hover {
                    background-color: #ddd;
                }

                &.active {
                    background-color: $secondary-color;
                    color: white;

                    svg path {
                        fill: white;
                    }

                    svg circle, svg line {
                        stroke: white;
                    }
                }
            }
        }

        div.distance-filter {
            text-align: center;
            font-family: 'Raleway', sans-serif;
            font-size: 16px;
            font-weight: bold;
            color: $secondary-color;
            border-bottom: 2px solid $secondary-color;
            border-top: 2px solid $secondary-color;
            border-left: 2px solid $secondary-color;
            border-right: 2px solid $secondary-color;
            width: 25%;
            display: inline-block;
            height: 50px;
            line-height: 46px;
            cursor: pointer;
            margin-bottom: 5px;

            &.active{
                color: white;
                background-color: $secondary-color;
            }

            &.first {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
            }

            &.second {
                border-left: none;
                border-right: none;
            }

            &.third {
                /*border-left: none;*/
                border-right: none;
            }

            &.fourth {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }
        }

        div.location-filter {
            text-align: center;
            font-family: 'Raleway', sans-serif;
            font-size: 16px;
            color: $secondary-color;
            border-bottom: 1px solid $secondary-color;
            border-top: 1px solid $secondary-color;
            border-left: 1px solid $secondary-color;
            border-right: 1px solid $secondary-color;
            width: 33%;
            display: inline-block;
            height: 55px;
            line-height: 55px;
            cursor: pointer;
            margin-bottom: 5px;

            &.active {
                color: white;
                background-color: $secondary-color;
            }

            &.first {
                border-top-left-radius: 5px;
                border-bottom-left-radius: 5px;
            }

            &.second {
                border-left: none;
                border-right: none;
            }

            &.third {
                border-top-right-radius: 5px;
                border-bottom-right-radius: 5px;
            }
        }

        div.close-filters {
            height: 90px;
            width: 23px;
            position: absolute;
            right: -20px;
            background-color: white;
            border-top-right-radius: 3px;
            border-bottom-right-radius: 3px;
            line-height: 90px;
            top: 50%;
            cursor: pointer;
            margin-top: -82px;
            text-align: center;
        }

        span.no-results {
            display: block;
            text-align: center;
            margin-top: 50px;
            color: #666666;
            text-transform: uppercase;
            font-weight: bold;
        }

        .centered {
            margin: auto;
        }

        a.search-button {
            display: block;
            text-align: center;
            height: 40px;
            color: white;
            border-radius: 5px;
            font-size: 16px;
            font-weight: 700 !important;
            font-family: 'Raleway', sans-serif;
            background-color: $secondary-color;
            -webkit-appearance: none;
            transition: color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),box-shadow .2s cubic-bezier(0.55, 0.085, 0.68, 0.53),background-color .2s cubic-bezier(0.55, 0.085, 0.68, 0.53);
            border: none;
            line-height: 40px;
            margin-bottom: 60px;
            margin-top: 20px;

            &:hover {
                background-color: #810050;
            }

            &:active {
                background: #ffffff;
                color: $secondary-color;
            }
        }
    }

    .pac-container:after {
        background-image: none !important;
        height: 0px;
    }

    /* Small only */
    @media screen and (max-width: 39.9375em) {
        div.filters-container{
            padding-top: 25px;
            overflow-y: auto;

            span.clear-filters{
                display: block;
            }

            div.close-filters{
                display: none;
            }
        }
    }

    /* Medium only */
    @media screen and (min-width: 40em) and (max-width: 63.9375em) {

    }

    /* Large only */
    @media screen and (min-width: 64em) and (max-width: 74.9375em) {

    }
</style>

<template>
    <transition name="slide-in-left">
        <div class="filters-container" id="filters-container" v-show="showFilters">
            <!--
            <div class="close-filters" v-on:click="toggleShowFilters()">
                <img src="/img/grey-left.svg"/>
            </div>
            -->

            <!--
            <div class="grid-x grid-padding-x" id="text-container">
                <div class="large-12 medium-12 small-12 cell">
                    <span class="clear-filters" v-show="showFilters" v-on:click="clearFilters()">
                        <img src="/img/clear-filters-icon.svg"/> Vymazat filtraci
                    </span>
                </div>
            </div>
            -->

            <div class="grid-x grid-padding-x" v-show="workroom != 860">
                <div class="large-12 medium-12 small-12 cell">
                    <span class="filters-header" style="font-weight: bold;">{{ $t('filter.serviceSelect') }}</span>
                </div>
            </div>

            <div id="service-type-container" v-show="workroom != 860">
                <div class="grid-x grid-padding-x">
                    <div class="large-12 medium-12 small-12 cell">
                        <div class="services">
                            <button class="service-button" v-on:click="changeServiceType(20)" v-bind:class="{'active': workroom == 20 && !makeId}">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.28402 2.97343L8.03035 4.71974C8.17098 4.8604 8.25003 5.05116 8.25003 5.25008V7.50008C8.25003 7.9143 7.91425 8.25008 7.50001 8.25008H5.25001C5.0511 8.25008 4.86034 8.17103 4.71968 8.0304L2.97336 6.28409C2.91845 6.66846 2.92324 7.06131 2.98968 7.44854C3.12081 8.21287 3.48568 8.91773 4.03402 9.46605C4.58237 10.0144 5.28723 10.3792 6.05154 10.5104C6.81585 10.6415 7.60203 10.5325 8.30178 10.1983C8.58858 10.0613 8.93058 10.12 9.15535 10.3448L13.6554 14.8447C13.8131 15.0025 14.027 15.0911 14.25 15.0911C14.4731 15.0911 14.687 15.0025 14.8447 14.8447C15.0024 14.687 15.091 14.4731 15.091 14.2501C15.091 14.027 15.0024 13.8131 14.8447 13.6554L10.3447 9.1554C10.1199 8.93062 10.0613 8.58863 10.1982 8.30183C10.5324 7.60208 10.6415 6.81591 10.5104 6.0516C10.3792 5.28729 10.0143 4.58243 9.466 4.03409C8.91768 3.48574 8.21283 3.12088 7.44848 2.98974C7.06125 2.9233 6.6684 2.91851 6.28402 2.97343ZM4.55179 1.9483C5.53147 1.48041 6.6321 1.32776 7.70215 1.51134C8.77218 1.69493 9.75895 2.20574 10.5267 2.97342C11.2944 3.74111 11.8052 4.72791 11.9888 5.79795C12.1417 6.68956 12.0612 7.60245 11.7594 8.44882L15.9054 12.5947C16.3443 13.0338 16.591 13.6292 16.591 14.2501C16.591 14.8709 16.3443 15.4663 15.9054 15.9054C15.4663 16.3444 14.8709 16.5911 14.25 16.5911C13.6291 16.5911 13.0337 16.3444 12.5947 15.9054L8.44878 11.7595C7.60233 12.0613 6.6895 12.1417 5.79789 11.9888C4.72785 11.8052 3.74104 11.2944 2.97336 10.5267C2.20567 9.75908 1.69487 8.77222 1.51128 7.7022C1.32769 6.63216 1.48035 5.53153 1.94824 4.55185C2.05316 4.33214 2.25822 4.17705 2.49818 4.13588C2.73815 4.0947 2.98318 4.17258 3.15534 4.34474L5.56067 6.75008H6.75001V5.56073L4.34468 3.15541C4.17252 2.98324 4.09464 2.73822 4.13581 2.49825C4.17698 2.25828 4.33208 2.05323 4.55179 1.9483Z" fill="black"/>
                                </svg>
                                {{ $t('filter.serviceMaintenance') }}
                            </button>

                            <button class="service-button" v-on:click="changeServiceType(60)" v-bind:class="{'active': workroom == 60}">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M9 3C5.68629 3 3 5.68629 3 9C3 12.3137 5.68629 15 9 15C12.3137 15 15 12.3137 15 9C15 5.68629 12.3137 3 9 3ZM1.5 9C1.5 4.85786 4.85786 1.5 9 1.5C13.1421 1.5 16.5 4.85786 16.5 9C16.5 13.1421 13.1421 16.5 9 16.5C4.85786 16.5 1.5 13.1421 1.5 9Z" fill="black"/>
                                    <circle cx="9" cy="9" r="1.5" stroke="black" stroke-width="1.5"/>
                                    <circle cx="9" cy="9" r="4.5" stroke="black" stroke-width="1.5"/>
                                    <line x1="9" y1="7.5" x2="9" y2="4.5" stroke="black" stroke-width="1.5"/>
                                    <line x1="9" y1="13.5" x2="9" y2="10.5" stroke="black" stroke-width="1.5"/>
                                    <line x1="4.5" y1="9" x2="7.5" y2="9" stroke="black" stroke-width="1.5"/>
                                    <line x1="10.5" y1="9" x2="13.5" y2="9" stroke="black" stroke-width="1.5"/>
                                </svg>
                                {{ $t('filter.serviceTires') }}
                            </button>

                            <button class="service-button" v-on:click="changeServiceType(999)" v-bind:class="{'active': workroom == 20 && makeId}">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M8.99995 3C8.80105 3 8.61025 3.07902 8.46962 3.21967C8.33177 3.35756 8.2531 3.54359 8.25002 3.73826C8.25227 3.88472 8.21125 4.02851 8.13362 4.15132C8.0773 4.24048 8.00162 4.31859 7.90915 4.37862C7.87667 4.39985 7.84232 4.41861 7.80655 4.43465C7.07435 4.78397 6.45008 5.32481 5.99995 6C5.55009 6.67479 5.291 7.45852 5.24995 8.2683V10.5C5.24995 10.5302 5.24813 10.5602 5.24451 10.5901C5.18432 11.0874 5.02525 11.5667 4.77761 12H13.2223C12.9746 11.5667 12.8156 11.0874 12.7553 10.5901C12.7517 10.5602 12.7499 10.5302 12.7499 10.5V8.2683C12.7089 7.45852 12.4498 6.67479 11.9999 6C11.5469 5.32051 10.9176 4.77711 10.1793 4.42802C9.91712 4.30405 9.74995 4.04002 9.74995 3.75C9.74995 3.55108 9.6709 3.36032 9.53027 3.21967C9.38965 3.07902 9.19885 3 8.99995 3ZM6.80244 3.26679C6.894 2.85044 7.10281 2.46516 7.40896 2.15901C7.83092 1.73705 8.40325 1.5 8.99995 1.5C9.59665 1.5 10.169 1.73705 10.5909 2.15901C10.8971 2.46516 11.1059 2.85044 11.1974 3.26679C12.0194 3.72918 12.7226 4.37993 13.248 5.16795C13.852 6.07393 14.198 7.12718 14.2491 8.21483C14.2496 8.22653 14.2499 8.2383 14.2499 8.25V10.4515C14.2968 10.7861 14.4185 11.1061 14.6061 11.3876C14.8015 11.6806 15.0629 11.9238 15.3695 12.0974C15.6659 12.2652 15.812 12.6117 15.7252 12.9411C15.6384 13.2705 15.3406 13.5 14.9999 13.5H2.99995C2.65933 13.5 2.36149 13.2705 2.2747 12.9411C2.18792 12.6117 2.33399 12.2652 2.63039 12.0974C2.93691 11.9238 3.1984 11.6806 3.3938 11.3876C3.58143 11.1061 3.70309 10.7861 3.74995 10.4515V8.25C3.74995 8.2383 3.75023 8.22653 3.75077 8.21483C3.80183 7.12718 4.14789 6.07393 4.75187 5.16795C5.27722 4.37993 5.98047 3.72918 6.80244 3.26679Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.75 12C7.16421 12 7.5 12.3358 7.5 12.75V13.5C7.5 13.8978 7.65803 14.2793 7.93935 14.5606C8.22068 14.842 8.6022 15 9 15C9.3978 15 9.77932 14.842 10.0606 14.5606C10.342 14.2793 10.5 13.8978 10.5 13.5V12.75C10.5 12.3358 10.8358 12 11.25 12C11.6642 12 12 12.3358 12 12.75V13.5C12 14.2957 11.6839 15.0587 11.1213 15.6213C10.5587 16.1839 9.79568 16.5 9 16.5C8.20432 16.5 7.44129 16.1839 6.87868 15.6213C6.31607 15.0587 6 14.2957 6 13.5V12.75C6 12.3358 6.33579 12 6.75 12Z" fill="black"/>
                                </svg>
                                {{ $t('filter.serviceCallingAction') }}
                            </button>

                            <button class="service-button" v-on:click="changeServiceType(888)">
                                <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M14.0303 4.71967C14.3232 5.01257 14.3232 5.48743 14.0303 5.78033L13.2803 6.53033C12.9874 6.82322 12.5125 6.82322 12.2197 6.53033C11.9268 6.23744 11.9268 5.76256 12.2197 5.46967L12.9697 4.71967C13.2625 4.42678 13.7374 4.42678 14.0303 4.71967Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M12.2197 3.96967C12.5126 3.67678 12.9874 3.67678 13.2803 3.96967L15.5303 6.21967C15.6709 6.36032 15.75 6.55108 15.75 6.75V12C15.75 12.4972 15.5524 12.9742 15.2008 13.3258C14.8492 13.6774 14.3723 13.875 13.875 13.875C13.3777 13.875 12.9008 13.6774 12.5492 13.3258C12.1976 12.9742 12 12.4972 12 12V9.75C12 9.5511 11.9209 9.3603 11.7803 9.21968C11.6397 9.07905 11.4489 9 11.25 9H10.5C10.0858 9 9.75 8.66423 9.75 8.25C9.75 7.83577 10.0858 7.5 10.5 7.5H11.25C11.8468 7.5 12.419 7.73708 12.841 8.15903C13.2629 8.58098 13.5 9.15322 13.5 9.75V12C13.5 12.0995 13.5395 12.1948 13.6098 12.2652C13.6802 12.3355 13.7755 12.375 13.875 12.375C13.9745 12.375 14.0698 12.3355 14.1402 12.2652C14.2105 12.1948 14.25 12.0995 14.25 12V7.06066L12.2197 5.03033C11.9268 4.73743 11.9268 4.26257 12.2197 3.96967Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M4.5 3.75C4.30108 3.75 4.11032 3.82902 3.96967 3.96967C3.82902 4.11032 3.75 4.30108 3.75 4.5V15C3.75 15.4142 3.41421 15.75 3 15.75C2.58579 15.75 2.25 15.4142 2.25 15V4.5C2.25 3.90326 2.48705 3.33097 2.90901 2.90901C3.33097 2.48705 3.90326 2.25 4.5 2.25H9C9.5967 2.25 10.169 2.48705 10.591 2.90901C11.0129 3.33097 11.25 3.90326 11.25 4.5V15C11.25 15.4142 10.9142 15.75 10.5 15.75C10.0858 15.75 9.75 15.4142 9.75 15V4.5C9.75 4.30108 9.67095 4.11032 9.53032 3.96967C9.3897 3.82902 9.1989 3.75 9 3.75H4.5Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M7.13588 7.98184C7.49106 8.19499 7.6062 8.65564 7.39312 9.01084L6.94964 9.74997H7.875C8.14523 9.74997 8.39453 9.89532 8.52765 10.1304C8.66078 10.3656 8.65718 10.6542 8.51813 10.8858L7.39312 12.7608C7.18001 13.116 6.71931 13.2312 6.36413 13.0181C6.00894 12.805 5.89377 12.3443 6.10688 11.9891L6.55036 11.25H5.625C5.3548 11.25 5.10548 11.1046 4.97235 10.8695C4.83922 10.6344 4.84286 10.3458 4.98188 10.1141L6.10688 8.23909C6.32 7.88397 6.78069 7.76877 7.13588 7.98184Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M1.5 15C1.5 14.5858 1.83579 14.25 2.25 14.25H11.25C11.6642 14.25 12 14.5858 12 15C12 15.4142 11.6642 15.75 11.25 15.75H2.25C1.83579 15.75 1.5 15.4142 1.5 15Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 6C2.25 5.58579 2.58579 5.25 3 5.25H10.5C10.9142 5.25 11.25 5.58579 11.25 6C11.25 6.41421 10.9142 6.75 10.5 6.75H3C2.58579 6.75 2.25 6.41421 2.25 6Z" fill="black"/>
                                </svg>
                                {{ $t('filter.serviceChargingStations') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-x grid-padding-x">
                <div class="large-12 medium-12 small-12 cell">
                    <span class="filters-header">{{ $t('filter.searchAddress') }}</span>
                </div>
            </div>

            <div class="grid-x grid-padding-x" id="text-container">
                <div class="large-12 medium-12 small-12 cell">
                    <vue-google-autocomplete
                            id="address-filter"
                            country="cz"
                            classname="search"
                            :placeholder="$t('filter.searchAddressPlaceholder')"
                            v-on:placechanged="getAddressData"
                    >
                    </vue-google-autocomplete>

                    <div class="validation" v-show="!validations.selected_address.is_valid">{{ validations.selected_address.text }}</div>
                </div>
            </div>

            <div id="location-type-container" v-show="workroom != 860">
                <div class="grid-x grid-padding-x">
                    <div class="large-12 medium-12 small-12 cell">
                        <label class="filter-label">{{ $t('filter.searchArea') }}</label>
                    </div>
                </div>

                <div class="grid-x grid-padding-x">
                    <div class="large-12 medium-12 small-12 cell">
                        <div class="distance-filter first" v-bind:class="{ 'active': this.selectedDistance == 10 }" v-on:click="setActiveDistanceFilter(10)">10 km</div><div class="distance-filter second" v-bind:class="{ 'active': this.selectedDistance == 20 }" v-on:click="setActiveDistanceFilter(20)">20 km</div><div class="distance-filter third" v-bind:class="{ 'active': this.selectedDistance == 40 }" v-on:click="setActiveDistanceFilter(40)">40 km</div><div class="distance-filter fourth" v-bind:class="{ 'active': this.selectedDistance == 60 }" v-on:click="setActiveDistanceFilter(60)">60 km</div>
                    </div>
                </div>
            </div>

            <div class="grid-x grid-padding-x">
                <div class="large-6 medium-6 small-6 cell centered">
                    <a class="search-button" v-on:click="clickedSearchButton()">{{ $t('filter.submitSearch') }}</a>
                </div>
            </div>

            <!--
            <div id="location-type-container">
                <div class="grid-x grid-padding-x">
                    <div class="large-12 medium-12 small-12 cell">
                        <label class="filter-label">Typy servisů</label>
                    </div>
                </div>

                <div class="grid-x grid-padding-x">
                    <div class="large-12 medium-12 small-12 cell">
                        <div class="location-filter first" v-bind:class="{ 'active': activeLocationFilter == 'all' }" v-on:click="setActiveLocationFilter('all')">Všechny</div><div class="location-filter second" v-bind:class="{ 'active': activeLocationFilter == 'slots' }" v-on:click="setActiveLocationFilter('slots')">Slotované</div><div class="location-filter third" v-bind:class="{ 'active': activeLocationFilter == 'clients' }" v-on:click="setActiveLocationFilter('clients')">Klientské</div>
                    </div>
                </div>
            </div>
            -->
        </div>
    </transition>
</template>

<script>
    import { EventBus } from '../../event-bus.js';
    import VueGoogleAutocomplete from './VueGoogleAutocomplete'
    import API from "../../api/service";

    export default {
        components: {
            VueGoogleAutocomplete
        },

        data: function () {
            return {
                isMobile: window.innerWidth <= 768,

                address: '',
                selectedDistance: '',

                validations: {
                    selected_address: {
                        is_valid: true,
                        text: ''
                    },
                }
            }
        },

        mounted() {
            EventBus.$on('show-filters', function() {
                this.show = true;
            }.bind(this));

            EventBus.$on('clear-filters', function() {
                this.clearFilters();
            }.bind(this));

            if (this.activeDistanceFilter) {
                this.selectedDistance = this.activeDistanceFilter;
            }

            window.addEventListener('resize', this.checkScreenSize);
        },

        beforeDestroy() {
            window.removeEventListener('resize', this.checkScreenSize);
        },

        watch: {
            'activeDistanceFilter': function() {
                if (this.activeDistanceFilter) {
                    this.selectedDistance = this.activeDistanceFilter;
                }
            }
            /*'distanceFilter': function() {
                if (this.distanceFilter != '') {
                    EventBus.$emit('distance-selected', parseFloat(this.distanceFilter));

                    this.$router.push({ name: 'services' });
                } else {
                    this.$router.push({ name: 'services' });
                }
            },
            */
        },

        computed: {
            /*
            distanceFilter: {
                set(distanceFilter) {
                    this.$store.commit('setDistanceFilter', distanceFilter);
                },
                get() {
                    return this.$store.getters.getDistanceFilter;
                }
            },
            */

            activeDistanceFilter() {
                return this.$store.getters.getDistanceFilter;
            },

            showFilters(){
                return this.$store.getters.getShowFilters;
            },

            servicesView() {
                return this.$store.getters.getServicesView;
            },

            workroom() {
                return this.$store.getters.getWorkroom;
            },

            makeId() {
                return this.$store.getters.getMakeId;
            },

            licensePlate() {
                return this.$store.getters.getLicensePlate;
            },

            /*
            activeLocationFilter() {
                return this.$store.getters.getActiveLocationFilter;
            },
            */
        },

        methods: {
            changeServiceType(workroomId) {
                if (this.licensePlate) {
                    API.postAuthorize(this.licensePlate)
                        .then((response) => {
                            if (response.status === 200) {
                                if (workroomId == 20 || workroomId == 60) {
                                    this.submitType(workroomId, response);
                                } else if (workroomId == 999) {
                                    this.submitCallingAction(20, response);
                                } else if (workroomId == 888) {
                                    this.submitChargingStation(response);
                                }
                            }
                        })
                        .catch((error) => {
                            this.logout();

                            this.$store.dispatch('flashMessageShow', { type: 'error', message: this.$t('auth.errorMessageLogin') }, { root: true })
                        });
                } else {
                    localStorage.clear();

                    this.$router.replace({ name: 'login' });

                    window.location.reload();
                }
            },

            submitType(type_id, response) {
                localStorage.removeItem('make_id');
                this.$store.commit('setMakeId', null);

                return this.$store.dispatch('setJwt', response.data.jwt).then(() => {
                    return this.$store.dispatch('setWorkroom', type_id).then(() => {
                        return this.$store.dispatch('setMaintenanceIncluded', response.data.maintenance_included).then(() => {
                            return this.$store.dispatch('setReplCarEntitlementCode', response.data.repl_car_entitlement_code).then(() => {
                                return this.$store.dispatch('setLicensePlate', response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                    EventBus.$emit('type-switched');

                                    if (this.$route.name != 'services') {
                                        this.$router.push({ name: 'services' });
                                    }
                                });
                            }, () => {});
                        }, () => {});
                    }, () => {});
                }, () => {});
            },

            submitCallingAction(type_id, response) {
                return this.$store.dispatch('setJwt', response.data.jwt).then(() => {
                    return this.$store.dispatch('setWorkroom', type_id).then(() => {
                        return this.$store.dispatch('setMaintenanceIncluded', response.data.maintenance_included).then(() => {
                            return this.$store.dispatch('setReplCarEntitlementCode', response.data.repl_car_entitlement_code).then(() => {
                                return this.$store.dispatch('setMakeId', response.data.make_id).then(() => {
                                    return this.$store.dispatch('setLicensePlate', response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                        EventBus.$emit('type-switched');

                                        if (this.$route.name != 'services') {
                                            this.$router.push({ name: 'services' });
                                        }
                                    });
                                }, () => {});
                            }, () => {});
                        }, () => {});
                    }, () => {});
                }, () => {});
            },

            submitChargingStation(response) {
                return this.$store.dispatch('setJwt', response.data.jwt).then(() => {
                    return this.$store.dispatch('setMaintenanceIncluded', response.data.maintenance_included).then(() => {
                        return this.$store.dispatch('setReplCarEntitlementCode', response.data.repl_car_entitlement_code).then(() => {
                            return this.$store.dispatch('setMakeId', response.data.make_id).then(() => {
                                return this.$store.dispatch('setLicensePlate', response.data.license_plate).then(() => {}, () => {}).finally(() => {
                                    if (this.$route.name != 'charging-stations') {
                                        this.$router.push({ name: 'charging-stations' });
                                    }
                                });
                            }, () => {});
                        }, () => {});
                    }, () => {});
                }, () => {});
            },

            checkScreenSize() {
                this.isMobile = window.innerWidth <= 768;
            },

            setActiveDistanceFilter(filter) {
                if (filter != '') {
                    this.selectedDistance = filter;

                    if (this.$router.currentRoute.name == 'service') {
                        this.$router.push({ name: 'services' });
                    }

                    //this.$store.commit('setDistanceFilter', filter);

                    //EventBus.$emit('distance-selected', parseFloat(filter));

                    /*this.$store.dispatch('toggleShowFilters', {
                        showFilters : !this.showFilters
                    });*/

                    //this.$router.push({ name: 'services' });
                } else {
                    this.$router.push({ name: 'services' });
                }
            },

            getAddressData: function (addressData, placeResultData, id) {
                if (addressData != '') {
                    this.address = addressData;

                    //this.$store.commit('setAddressFilter', filter);

                    if (this.$router.currentRoute.name == 'service') {
                        this.$router.push({ name: 'services' });
                    }

                    //this.$store.commit('setClientCurrentLocation', { location: { latitude: addressData.latitude, longitude: addressData.longitude } })

                    //EventBus.$emit('address-entered', addressData);

                    /*
                    this.$store.dispatch('toggleShowFilters', {
                        showFilters : !this.showFilters
                    });
                    */

                    //this.$router.push({ name: 'services' });
                } else {
                    this.$router.push({ name: 'services' });
                }
            },

            clickedSearchButton() {
                if (this.validateFilters()) {
                    if (this.isMobile) {
                        this.$store.dispatch('toggleShowFilters', {
                            showFilters : !this.showFilters
                        });
                    }

                    if (this.address) {
                        if (this.activeDistanceFilter == 250) {
                            this.selectedDistance = 20;
                        }

                        this.$store.commit('setClientCurrentLocation', { location: { latitude: this.address.latitude, longitude: this.address.longitude } })
                        //EventBus.$emit('address-entered', this.address);
                    }

                    if (this.selectedDistance) {
                        this.$store.commit('setDistanceFilter', this.selectedDistance);
                        //EventBus.$emit('distance-selected', parseFloat(this.activeDistanceFilter));
                    }

                    EventBus.$emit('search-submitted', parseFloat(this.activeDistanceFilter));
                }
            },

            /*
            setActiveLocationFilter(filter) {
                this.$store.dispatch('updateActiveLocationFilter', filter);
            },
            */

            toggleShowFilters() {
                this.$store.dispatch('toggleShowFilters', {
                    showFilters : !this.showFilters
                });
            },

            clearFilters() {
                this.$store.dispatch('resetFilters');
            },

            validateFilters() {
                let validFilterForm = true;

                if (this.address == '' && ($("input[id=address-filter]").val().length > 0)) {
                    validFilterForm = false;
                    this.validations.selected_address.is_valid = false;
                    this.validations.selected_address.text = this.$t('filter.searchAddressSelectNote');
                    $("input[id=address-filter]").focus();
                } else {
                    this.validations.selected_address.is_valid = true;
                    this.validations.selected_address.text = '';
                }

                return validFilterForm;
            },

            logout() {
                this.$store.dispatch('logoutClient').then(() => {}, () => {}).finally(() => {
                    localStorage.clear();

                    this.$store.commit('setDistanceFilter', 10);
                    this.$store.commit('setClientCurrentLocation', '');
                    this.$store.commit('setServices', []);
                    this.$store.commit('setLicensePlate', null);
                    this.$store.commit('setClientPersonalData', null);

                    this.$router.replace({ name: 'login' });

                    window.location.reload();
                });
            }
        }
    }
</script>
